import React, { useState, useEffect } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import DataTable from '../../../components/Content/DataTable';

// Date & Time
import Datetime from 'react-datetime';
import moment from 'moment';

// Utils
import { getAlert,updateData } from '../../../../utils/SamuiUtils';
import { formatStringDateToDate, formatThaiDateUi } from '../../../../utils/DateUtils';

// Components Date Filter
import DateFilterTable from '../../../components/Content/DateFilterTable';

function Main({ masterList, detailList, statusColours, name, onPageInsert, onRowSelected, getReport }) {
    const [dataMasterList, setDataMasterList] = useState([]);
    const [dataDetailList, setDataDetailList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(16);

    // StatusColours
    const [countNewRec, setCountNewRec] = useState(0);
    const [countInStock, setCountInStock] = useState(0);
    const [countCancel, setCountCancel] = useState(0);

    // ใช้สำหรับค้นหาเอกสาร
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);

    // Filter by date & Sort by field
    const [startDate, setStartDate] = useState(moment().startOf('month').add(543, 'year').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().add(543, 'year').format('YYYY-MM-DD'));
    const [sortOrder, setSortOrder] = useState('');
    const [sortField, setSortField] = useState('');
    const [selectedDateType, setSelectedDateType] = useState('1');
    const [allDates, setAllDates] = useState(false);

    useEffect(() => {
        initialize();
    }, [masterList, detailList]);

    useEffect(() => {
        setCurrentPage(1);
        filterItems();
    }, [searchTerm, dataMasterList]);

    // Remove reset of sortField on date change to persist user sorting preference
    // useEffect(() => {
    //     setSortField('');
    // }, [startDate, endDate]);

    const initialize = async () => {
        try {
            if (masterList && masterList.length > 0) {
                setDataMasterList(masterList);

                // นับข้อมูลสถานะ
                let statusCounts = {
                    'ใบใหม่': 0,
                    'รับเข้าสต๊อคแล้ว': 0,
                    'ยกเลิก': 0
                };

                masterList.forEach(data => {
                    if (data.RecStatus_Name) {
                        statusCounts[data.RecStatus_Name] = (statusCounts[data.RecStatus_Name] || 0) + 1;
                    }
                });

                setCountNewRec(statusCounts['ใบใหม่']);
                setCountInStock(statusCounts['รับเข้าสต๊อคแล้ว']);
                setCountCancel(statusCounts['ยกเลิก']);

                setCurrentPage(1); // รีเซ็ตหน้าเมื่อมีข้อมูลใหม่
            }

            if (detailList && detailList.length > 0) {
                setDataDetailList(detailList);

            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    const filterItems = () => {
        if (searchTerm === '') {
            setFilteredItems(dataMasterList);
        } else {
            const lowercasedSearchTerm = searchTerm.toLowerCase();
            const filtered = dataMasterList.filter(item =>
                Object.values(item).some(value =>
                    typeof value === 'string' &&
                    value.toLowerCase().includes(lowercasedSearchTerm)
                )
            );
            setFilteredItems(filtered);
        }
    };

    // filter วันที่
    const filterItemsByDate = async (type) => {
        // If selecting all dates, don't filter on client
        if (allDates) {
            setFilteredItems(dataMasterList);
            return;
        }
        let filteredByDate = dataMasterList;

        if (startDate && endDate) {
            // แปลง startDate และ endDate จาก YYYY-MM-DD (พ.ศ.) เป็น moment และลบ 543 ปีกลับเป็น ค.ศ.
            const start = moment(startDate, "YYYY-MM-DD").subtract(543, 'year');
            const end = moment(endDate, "YYYY-MM-DD").subtract(543, 'year').endOf("day");

            filteredByDate = dataMasterList.filter(item => {
                // แปลงวันที่จาก ISO string (2025-09-19T00:00:00.000Z) เป็น moment
                const itemDate = type === 'documentDate'
                    ? moment(item.Rec_Date)
                    : type === 'dueDate'
                        ? moment(item.Rec_DueDate)
                        : null;
                if (!itemDate || !itemDate.isValid()) return false;

                const isBetween = itemDate.isBetween(start, end, null, '[]');
                return isBetween;
            });
        }

        // Apply current sorting if set
        if (sortField) {
            filteredByDate.sort((a, b) => {
                let aValue = a[sortField] || "";
                let bValue = b[sortField] || "";

                if (sortOrder === "asc") {
                    return aValue.localeCompare(bValue);
                } else {
                    return bValue.localeCompare(aValue);
                }
            });
        }

        setFilteredItems(filteredByDate);
    };

    //ค้นหาวันที่และเลขเอกสาร
    const handleSearch = () => {
        const type = selectedDateType === '1' ? 'documentDate' : 'dueDate';
        filterItemsByDate(type);
    };

    // Clear search and date filters
    const handleClear = () => {
        setSearchTerm('');
        setStartDate(moment().startOf('month').add(543, 'year').format('YYYY-MM-DD'));
        setEndDate(moment().add(543, 'year').format('YYYY-MM-DD'));
        setSelectedDateType('1');
        setFilteredItems(dataMasterList);
        setSortField('')
        setSortOrder('desc')
    };

    // Sort เรียงลำดับ asc to desc
    const handleSort = () => {
        if (!sortField) return;
        // การเรียงจะขึ้นอยู่กับค่าของ newSortOrder
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);

        const sortedItems = [...filteredItems].sort((a, b) => {
            // ถ้า newSortOrder เป็น 'asc' จะเรียงจากน้อยไปมาก
            if (newSortOrder === 'asc') {
                return a[sortField].localeCompare(b[sortField]);
            } else {
                // ถ้าเป็น 'desc' จะเรียงจากมากไปน้อย
                return b[sortField].localeCompare(a[sortField]);
            }
        });
        setFilteredItems(sortedItems);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    // สามารถใช้กรองคำที่จะไม่ใช้ใน Counter Box ได้
    // const filteredStatusColours = statusColours.filter(statusObj =>
    //     !['รออนุมัติ', 'ไม่อนุมัติ'].includes(statusObj.DocSetStaus_Name)
    // );
    const updateStatus = async (Doc_No) => {
        try {
          const newStatus = 4;
          const values = { Doc_Status: newStatus };
          const where = { Doc_No };
    
          console.debug("📌 กำลังอัปเดต PO_H:", values, where);
    
          const res = await updateData("PO_H", values, where);
          console.log("🔍 ผลลัพธ์ updateData:", res);
          if (res && res.result && res.result.rowsAffected && res.result.rowsAffected[0] > 0) {
            console.debug("✅ อัปเดตสถานะสำเร็จ! กำลังโหลดข้อมูลใหม่...");
            setDataMasterList([]);
            setFilteredItems([]);
    
            await new Promise((resolve) => setTimeout(resolve, 100));
    
            setTimeout(() => {
              window.location.reload();
            }, 300);
          } else {
            throw new Error(
              "⚠️ ไม่สามารถอัปเดตสถานะได้ หรือไม่มีข้อมูลถูกเปลี่ยนแปลง"
            );
          }
        } catch (error) {
          console.error("❌ อัปเดตล้มเหลว:", error);
          getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการอัปเดต");
        }
      };

    return (
        <>
            <div className="page-header d-flex justify-content-between align-items-center mb-0">
                <Breadcrumbs page={name} items={[
                    { name: 'จัดซื้อสินค้า', url: '/purchase' },
                    { name: name, url: '/product-receipt' },
                ]} />
            </div>
            <div className="row" style={{ maxHeight: "85vh", overflowY: "auto" }}>
                {/* <div className="col-1">
                    <center>
                        <b>สถานะเอกสาร</b>
                    </center>
                    <br />
                    {statusColours.map((statusObj, index) => {
                        const { DocSetStaus_Name, DocSetColour } = statusObj;
                        let count;

                        switch (DocSetStaus_Name) {
                            case 'ใบใหม่':
                                count = countNewRec;
                                break;
                            case 'รับเข้าสต๊อคแล้ว':
                                count = countInStock;
                                break;
                            case 'ยกเลิก':
                                count = countCancel;
                                break;
                            default:
                                count = 0;
                        }

                        return (
                            <div key={index} className="col-12 mb-3">
                                <div className="card text-center" style={{ backgroundColor: DocSetColour }}>
                                    <div className="card-body d-flex flex-column align-items-center text-white">
                                        <div className="row">
                                            <div className="col-12">
                                                <b style={{ fontSize: '20px', textAlign: 'center' }}>{count}</b>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <b style={{ fontSize: '16px', textAlign: 'center' }}>{DocSetStaus_Name}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div> */}
                <div className="col-12">
                    <div className='p-3 rounded-3 my-2 shadow-lg' style={{ backgroundColor: '#ffff' }}>
                        <div className='row  mb-2'>
                            <div className="col-3">
                                <div className="navbar-form nav-search">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            placeholder="ค้นหาเอกสาร..."
                                            className="form-control"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <span className="input-group-text">
                                            <i className="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-7 d-flex'>
                                <DateFilterTable
                                    startDate={startDate}
                                    endDate={endDate}
                                    setStartDate={setStartDate}
                                    setEndDate={setEndDate}
                                    selectedDateType={selectedDateType}
                                    setSelectedDateType={setSelectedDateType}
                                    handleSearch={handleSearch}
                                    allDates={allDates}
                                    setAllDates={setAllDates}
                                />
                            </div>
                            <div className="col-2 d-flex justify-content-end">
                                <button
                                    onClick={onPageInsert}
                                    className="btn btn-warning text-white ms-2"
                                    type="button"
                                >
                                    สร้าง{name} <i className="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div className='p-1 px-3 rounded-3 shadow-sm' style={{ backgroundColor: '#f5f7fd' }}>
                            <div className='row mb-2'>
                                <small className='d-block p-1 fw-bold' style={{
                                    borderLeft: '5px solid #EF6C00',
                                    borderRadius: '3px',
                                }}>
                                    เรียงลำดับตาม
                                </small>

                                <div className="col-1 d-flex justify-content-between">
                                    <div className="radio-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            checked={sortField === 'Doc_No'}
                                            onChange={() => setSortField('Doc_No')}
                                        />
                                        <label className="text-black">เลขที่เอกสาร</label>
                                    </div>
                                </div>
                                <div className="col-1 d-flex justify-content-between">
                                    <div className="radio-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            checked={sortField === 'Doc_Date'}
                                            onChange={() => setSortField('Doc_Date')}
                                        />
                                        <label className="text-black">วันที่เอกสาร</label>
                                    </div>
                                </div>
                                <div className="col-1 d-flex justify-content-between">
                                    <div className="radio-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            checked={sortField === 'Doc_DueDate'}
                                            onChange={() => setSortField('Doc_DueDate')}
                                        />
                                        <label className="text-black">Due Date</label>
                                    </div>
                                </div>
                                <div className="col-1 d-flex justify-content-between">
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={handleSort}
                                        style={{ cursor: 'pointer', color: 'black', backgroundColor: 'transparent' }}
                                    >
                                        <i className={`fas fa-arrow-${sortOrder === 'asc' ? 'up' : 'down'}`}></i> Sort
                                    </button>
                                </div>
                                <div className='col-8 d-flex justify-content-end'>
                                    <button
                                        onClick={handleClear}
                                        className="btn btn-danger text-white"
                                        type="button"
                                        style={{ padding: ' 0.9rem' }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DataTable
                        currentItems={currentItems}
                        onRowSelected={onRowSelected}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                        dataMasterList={filteredItems}
                        itemsPerPage={itemsPerPage}
                        updateStatus={updateStatus}
                        fieldMappings={{
                            no: 'Rec_No',
                            refDoc: 'Ref_Doc',
                            typeName: 'DocType_Name',
                            statusName: 'RecStatus_Name',
                            statusColor: 'RecStatus_Colour',
                            statusPaidName: 'DocStatusPaid_Name',
                            statusPaidColour: 'DocStatusPaid_Colour',
                            date: 'Rec_Date',
                            apCode: 'AP_Code',
                            apName: 'AP_Name',
                            dueDate: 'Rec_DueDate',
                            netTotal: 'NetTotal',
                            createdBy: 'Created_By_Name',
                            updatedBy: 'Update_By_Name'
                        }}
                        getReport={(docNo) => getReport('rec', docNo)}
                    />
                </div>
            </div>
        </>
    );
}

export default Main;